import type { GenerationKind } from "@dramapie/shared";

import { GENERATION_KIND_META } from "../lib/generations";

const KINDS: GenerationKind[] = ["keyframe", "endframe", "clip"];

export interface GenerationControlsProps {
  selectedCount: number;
  /** 正在预估的 kind；有值时三个按钮都禁用，避免连点打两次预估。 */
  busyKind?: GenerationKind | null;
  /** 故事板保存中等场景，整体禁用。 */
  disabled?: boolean;
  onRequest: (kind: GenerationKind) => void;
}

/**
 * 生成入口：选中镜头后才能点。
 * 点击只触发「预估」，真正的提交在确认层里，避免盲点扣钱。
 */
export function GenerationControls({
  selectedCount,
  busyKind = null,
  disabled = false,
  onRequest,
}: GenerationControlsProps) {
  const noSelection = selectedCount === 0;

  return (
    <div role="group" aria-label="生成" aria-busy={busyKind !== null} className="dp-gen">
      <span className="dp-gen-label">生成</span>
      {KINDS.map((kind) => {
        const meta = GENERATION_KIND_META[kind];
        return (
          <button
            key={kind}
            type="button"
            onClick={() => onRequest(kind)}
            disabled={disabled || noSelection || busyKind !== null}
            aria-label={meta.action}
            className="dp-btn sm"
          >
            {busyKind === kind ? "预估中…" : meta.action}
          </button>
        );
      })}
      <span className="dp-tiny-note">
        {noSelection
          ? "先勾选镜头（卡片底部的「选」）"
          : `已选 ${selectedCount} 镜 · 先预估，确认后才扣点`}
      </span>
    </div>
  );
}
